export default __webpack_public_path__ + "static/media/property_332.b00558f9.png";